import { useUsersStore } from '@/store/users-store';
import { storeToRefs } from 'pinia';
import { useVendorsStore } from '@/store/vendors-store';
import { useOnboarding } from '@/composables/onboarding';
import { Vendor } from '@/model/vendor';

export function useAppLoad() {
  const { isLoggedIn, isStaffOrMore, isAdmin, loggedInVendorId } = storeToRefs(
    useUsersStore(),
  );
  const usersStore = useUsersStore();
  const vendorsStore = useVendorsStore();
  const onboarding = useOnboarding();

  async function loadManagerData(): Promise<void> {
    if (isLoggedIn.value && isStaffOrMore.value) {
      await usersStore.loadDataForStaffUser();
      await startOnboardingWhenNecessary();
    }
  }

  async function startOnboardingWhenNecessary() {
    const vendor: Vendor = vendorsStore.getById(loggedInVendorId.value);
    if (
      isLoggedIn.value &&
      isAdmin.value &&
      vendor &&
      !vendor.onboarding_completed
    ) {
      await onboarding.start();
    }
  }

  return {
    loadManagerData,
  };
}
